/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as Char123LocaleChar125RouteRouteImport } from './routes/{-$locale}/route'
import { Route as Char123LocaleChar125IndexRouteImport } from './routes/{-$locale}/index'
import { Route as Char123LocaleChar125AdminPanelRouteRouteImport } from './routes/{-$locale}/admin-panel/route'
import { Route as Char123LocaleChar125AuthRouteRouteImport } from './routes/{-$locale}/_auth/route'
import { Route as Char123LocaleChar125OrderPrintoutOrderIdRouteImport } from './routes/{-$locale}/order-printout.$orderId'
import { Route as Char123LocaleChar125AdminPanelUsersRouteImport } from './routes/{-$locale}/admin-panel/users'
import { Route as Char123LocaleChar125AdminPanelServicesRouteImport } from './routes/{-$locale}/admin-panel/services'
import { Route as Char123LocaleChar125AdminPanelServiceCategoriesRouteImport } from './routes/{-$locale}/admin-panel/service-categories'
import { Route as Char123LocaleChar125AdminPanelReviewsRouteImport } from './routes/{-$locale}/admin-panel/reviews'
import { Route as Char123LocaleChar125AdminPanelOrdersRouteImport } from './routes/{-$locale}/admin-panel/orders'
import { Route as Char123LocaleChar125AdminPanelInquiriesRouteImport } from './routes/{-$locale}/admin-panel/inquiries'
import { Route as Char123LocaleChar125AdminPanelDocumentationRouteImport } from './routes/{-$locale}/admin-panel/documentation'
import { Route as Char123LocaleChar125AdminPanelDashboardRouteImport } from './routes/{-$locale}/admin-panel/dashboard'
import { Route as Char123LocaleChar125AuthLoginRouteImport } from './routes/{-$locale}/_auth/login'

const Char123LocaleChar125RouteRoute =
  Char123LocaleChar125RouteRouteImport.update({
    id: '/{-$locale}',
    path: '/{-$locale}',
    getParentRoute: () => rootRouteImport,
  } as any)
const Char123LocaleChar125IndexRoute =
  Char123LocaleChar125IndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => Char123LocaleChar125RouteRoute,
  } as any)
const Char123LocaleChar125AdminPanelRouteRoute =
  Char123LocaleChar125AdminPanelRouteRouteImport.update({
    id: '/admin-panel',
    path: '/admin-panel',
    getParentRoute: () => Char123LocaleChar125RouteRoute,
  } as any)
const Char123LocaleChar125AuthRouteRoute =
  Char123LocaleChar125AuthRouteRouteImport.update({
    id: '/_auth',
    getParentRoute: () => Char123LocaleChar125RouteRoute,
  } as any)
const Char123LocaleChar125OrderPrintoutOrderIdRoute =
  Char123LocaleChar125OrderPrintoutOrderIdRouteImport.update({
    id: '/order-printout/$orderId',
    path: '/order-printout/$orderId',
    getParentRoute: () => Char123LocaleChar125RouteRoute,
  } as any)
const Char123LocaleChar125AdminPanelUsersRoute =
  Char123LocaleChar125AdminPanelUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => Char123LocaleChar125AdminPanelRouteRoute,
  } as any)
const Char123LocaleChar125AdminPanelServicesRoute =
  Char123LocaleChar125AdminPanelServicesRouteImport.update({
    id: '/services',
    path: '/services',
    getParentRoute: () => Char123LocaleChar125AdminPanelRouteRoute,
  } as any)
const Char123LocaleChar125AdminPanelServiceCategoriesRoute =
  Char123LocaleChar125AdminPanelServiceCategoriesRouteImport.update({
    id: '/service-categories',
    path: '/service-categories',
    getParentRoute: () => Char123LocaleChar125AdminPanelRouteRoute,
  } as any)
const Char123LocaleChar125AdminPanelReviewsRoute =
  Char123LocaleChar125AdminPanelReviewsRouteImport.update({
    id: '/reviews',
    path: '/reviews',
    getParentRoute: () => Char123LocaleChar125AdminPanelRouteRoute,
  } as any)
const Char123LocaleChar125AdminPanelOrdersRoute =
  Char123LocaleChar125AdminPanelOrdersRouteImport.update({
    id: '/orders',
    path: '/orders',
    getParentRoute: () => Char123LocaleChar125AdminPanelRouteRoute,
  } as any)
const Char123LocaleChar125AdminPanelInquiriesRoute =
  Char123LocaleChar125AdminPanelInquiriesRouteImport.update({
    id: '/inquiries',
    path: '/inquiries',
    getParentRoute: () => Char123LocaleChar125AdminPanelRouteRoute,
  } as any)
const Char123LocaleChar125AdminPanelDocumentationRoute =
  Char123LocaleChar125AdminPanelDocumentationRouteImport.update({
    id: '/documentation',
    path: '/documentation',
    getParentRoute: () => Char123LocaleChar125AdminPanelRouteRoute,
  } as any)
const Char123LocaleChar125AdminPanelDashboardRoute =
  Char123LocaleChar125AdminPanelDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => Char123LocaleChar125AdminPanelRouteRoute,
  } as any)
const Char123LocaleChar125AuthLoginRoute =
  Char123LocaleChar125AuthLoginRouteImport.update({
    id: '/login',
    path: '/login',
    getParentRoute: () => Char123LocaleChar125AuthRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/{-$locale}': typeof Char123LocaleChar125AuthRouteRouteWithChildren
  '/{-$locale}/admin-panel': typeof Char123LocaleChar125AdminPanelRouteRouteWithChildren
  '/{-$locale}/': typeof Char123LocaleChar125IndexRoute
  '/{-$locale}/login': typeof Char123LocaleChar125AuthLoginRoute
  '/{-$locale}/admin-panel/dashboard': typeof Char123LocaleChar125AdminPanelDashboardRoute
  '/{-$locale}/admin-panel/documentation': typeof Char123LocaleChar125AdminPanelDocumentationRoute
  '/{-$locale}/admin-panel/inquiries': typeof Char123LocaleChar125AdminPanelInquiriesRoute
  '/{-$locale}/admin-panel/orders': typeof Char123LocaleChar125AdminPanelOrdersRoute
  '/{-$locale}/admin-panel/reviews': typeof Char123LocaleChar125AdminPanelReviewsRoute
  '/{-$locale}/admin-panel/service-categories': typeof Char123LocaleChar125AdminPanelServiceCategoriesRoute
  '/{-$locale}/admin-panel/services': typeof Char123LocaleChar125AdminPanelServicesRoute
  '/{-$locale}/admin-panel/users': typeof Char123LocaleChar125AdminPanelUsersRoute
  '/{-$locale}/order-printout/$orderId': typeof Char123LocaleChar125OrderPrintoutOrderIdRoute
}
export interface FileRoutesByTo {
  '/{-$locale}': typeof Char123LocaleChar125IndexRoute
  '/{-$locale}/admin-panel': typeof Char123LocaleChar125AdminPanelRouteRouteWithChildren
  '/{-$locale}/login': typeof Char123LocaleChar125AuthLoginRoute
  '/{-$locale}/admin-panel/dashboard': typeof Char123LocaleChar125AdminPanelDashboardRoute
  '/{-$locale}/admin-panel/documentation': typeof Char123LocaleChar125AdminPanelDocumentationRoute
  '/{-$locale}/admin-panel/inquiries': typeof Char123LocaleChar125AdminPanelInquiriesRoute
  '/{-$locale}/admin-panel/orders': typeof Char123LocaleChar125AdminPanelOrdersRoute
  '/{-$locale}/admin-panel/reviews': typeof Char123LocaleChar125AdminPanelReviewsRoute
  '/{-$locale}/admin-panel/service-categories': typeof Char123LocaleChar125AdminPanelServiceCategoriesRoute
  '/{-$locale}/admin-panel/services': typeof Char123LocaleChar125AdminPanelServicesRoute
  '/{-$locale}/admin-panel/users': typeof Char123LocaleChar125AdminPanelUsersRoute
  '/{-$locale}/order-printout/$orderId': typeof Char123LocaleChar125OrderPrintoutOrderIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/{-$locale}': typeof Char123LocaleChar125RouteRouteWithChildren
  '/{-$locale}/_auth': typeof Char123LocaleChar125AuthRouteRouteWithChildren
  '/{-$locale}/admin-panel': typeof Char123LocaleChar125AdminPanelRouteRouteWithChildren
  '/{-$locale}/': typeof Char123LocaleChar125IndexRoute
  '/{-$locale}/_auth/login': typeof Char123LocaleChar125AuthLoginRoute
  '/{-$locale}/admin-panel/dashboard': typeof Char123LocaleChar125AdminPanelDashboardRoute
  '/{-$locale}/admin-panel/documentation': typeof Char123LocaleChar125AdminPanelDocumentationRoute
  '/{-$locale}/admin-panel/inquiries': typeof Char123LocaleChar125AdminPanelInquiriesRoute
  '/{-$locale}/admin-panel/orders': typeof Char123LocaleChar125AdminPanelOrdersRoute
  '/{-$locale}/admin-panel/reviews': typeof Char123LocaleChar125AdminPanelReviewsRoute
  '/{-$locale}/admin-panel/service-categories': typeof Char123LocaleChar125AdminPanelServiceCategoriesRoute
  '/{-$locale}/admin-panel/services': typeof Char123LocaleChar125AdminPanelServicesRoute
  '/{-$locale}/admin-panel/users': typeof Char123LocaleChar125AdminPanelUsersRoute
  '/{-$locale}/order-printout/$orderId': typeof Char123LocaleChar125OrderPrintoutOrderIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/{-$locale}'
    | '/{-$locale}/admin-panel'
    | '/{-$locale}/'
    | '/{-$locale}/login'
    | '/{-$locale}/admin-panel/dashboard'
    | '/{-$locale}/admin-panel/documentation'
    | '/{-$locale}/admin-panel/inquiries'
    | '/{-$locale}/admin-panel/orders'
    | '/{-$locale}/admin-panel/reviews'
    | '/{-$locale}/admin-panel/service-categories'
    | '/{-$locale}/admin-panel/services'
    | '/{-$locale}/admin-panel/users'
    | '/{-$locale}/order-printout/$orderId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/{-$locale}'
    | '/{-$locale}/admin-panel'
    | '/{-$locale}/login'
    | '/{-$locale}/admin-panel/dashboard'
    | '/{-$locale}/admin-panel/documentation'
    | '/{-$locale}/admin-panel/inquiries'
    | '/{-$locale}/admin-panel/orders'
    | '/{-$locale}/admin-panel/reviews'
    | '/{-$locale}/admin-panel/service-categories'
    | '/{-$locale}/admin-panel/services'
    | '/{-$locale}/admin-panel/users'
    | '/{-$locale}/order-printout/$orderId'
  id:
    | '__root__'
    | '/{-$locale}'
    | '/{-$locale}/_auth'
    | '/{-$locale}/admin-panel'
    | '/{-$locale}/'
    | '/{-$locale}/_auth/login'
    | '/{-$locale}/admin-panel/dashboard'
    | '/{-$locale}/admin-panel/documentation'
    | '/{-$locale}/admin-panel/inquiries'
    | '/{-$locale}/admin-panel/orders'
    | '/{-$locale}/admin-panel/reviews'
    | '/{-$locale}/admin-panel/service-categories'
    | '/{-$locale}/admin-panel/services'
    | '/{-$locale}/admin-panel/users'
    | '/{-$locale}/order-printout/$orderId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  Char123LocaleChar125RouteRoute: typeof Char123LocaleChar125RouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/{-$locale}': {
      id: '/{-$locale}'
      path: '/{-$locale}'
      fullPath: '/{-$locale}'
      preLoaderRoute: typeof Char123LocaleChar125RouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/{-$locale}/': {
      id: '/{-$locale}/'
      path: '/'
      fullPath: '/{-$locale}/'
      preLoaderRoute: typeof Char123LocaleChar125IndexRouteImport
      parentRoute: typeof Char123LocaleChar125RouteRoute
    }
    '/{-$locale}/admin-panel': {
      id: '/{-$locale}/admin-panel'
      path: '/admin-panel'
      fullPath: '/{-$locale}/admin-panel'
      preLoaderRoute: typeof Char123LocaleChar125AdminPanelRouteRouteImport
      parentRoute: typeof Char123LocaleChar125RouteRoute
    }
    '/{-$locale}/_auth': {
      id: '/{-$locale}/_auth'
      path: ''
      fullPath: '/{-$locale}'
      preLoaderRoute: typeof Char123LocaleChar125AuthRouteRouteImport
      parentRoute: typeof Char123LocaleChar125RouteRoute
    }
    '/{-$locale}/order-printout/$orderId': {
      id: '/{-$locale}/order-printout/$orderId'
      path: '/order-printout/$orderId'
      fullPath: '/{-$locale}/order-printout/$orderId'
      preLoaderRoute: typeof Char123LocaleChar125OrderPrintoutOrderIdRouteImport
      parentRoute: typeof Char123LocaleChar125RouteRoute
    }
    '/{-$locale}/admin-panel/users': {
      id: '/{-$locale}/admin-panel/users'
      path: '/users'
      fullPath: '/{-$locale}/admin-panel/users'
      preLoaderRoute: typeof Char123LocaleChar125AdminPanelUsersRouteImport
      parentRoute: typeof Char123LocaleChar125AdminPanelRouteRoute
    }
    '/{-$locale}/admin-panel/services': {
      id: '/{-$locale}/admin-panel/services'
      path: '/services'
      fullPath: '/{-$locale}/admin-panel/services'
      preLoaderRoute: typeof Char123LocaleChar125AdminPanelServicesRouteImport
      parentRoute: typeof Char123LocaleChar125AdminPanelRouteRoute
    }
    '/{-$locale}/admin-panel/service-categories': {
      id: '/{-$locale}/admin-panel/service-categories'
      path: '/service-categories'
      fullPath: '/{-$locale}/admin-panel/service-categories'
      preLoaderRoute: typeof Char123LocaleChar125AdminPanelServiceCategoriesRouteImport
      parentRoute: typeof Char123LocaleChar125AdminPanelRouteRoute
    }
    '/{-$locale}/admin-panel/reviews': {
      id: '/{-$locale}/admin-panel/reviews'
      path: '/reviews'
      fullPath: '/{-$locale}/admin-panel/reviews'
      preLoaderRoute: typeof Char123LocaleChar125AdminPanelReviewsRouteImport
      parentRoute: typeof Char123LocaleChar125AdminPanelRouteRoute
    }
    '/{-$locale}/admin-panel/orders': {
      id: '/{-$locale}/admin-panel/orders'
      path: '/orders'
      fullPath: '/{-$locale}/admin-panel/orders'
      preLoaderRoute: typeof Char123LocaleChar125AdminPanelOrdersRouteImport
      parentRoute: typeof Char123LocaleChar125AdminPanelRouteRoute
    }
    '/{-$locale}/admin-panel/inquiries': {
      id: '/{-$locale}/admin-panel/inquiries'
      path: '/inquiries'
      fullPath: '/{-$locale}/admin-panel/inquiries'
      preLoaderRoute: typeof Char123LocaleChar125AdminPanelInquiriesRouteImport
      parentRoute: typeof Char123LocaleChar125AdminPanelRouteRoute
    }
    '/{-$locale}/admin-panel/documentation': {
      id: '/{-$locale}/admin-panel/documentation'
      path: '/documentation'
      fullPath: '/{-$locale}/admin-panel/documentation'
      preLoaderRoute: typeof Char123LocaleChar125AdminPanelDocumentationRouteImport
      parentRoute: typeof Char123LocaleChar125AdminPanelRouteRoute
    }
    '/{-$locale}/admin-panel/dashboard': {
      id: '/{-$locale}/admin-panel/dashboard'
      path: '/dashboard'
      fullPath: '/{-$locale}/admin-panel/dashboard'
      preLoaderRoute: typeof Char123LocaleChar125AdminPanelDashboardRouteImport
      parentRoute: typeof Char123LocaleChar125AdminPanelRouteRoute
    }
    '/{-$locale}/_auth/login': {
      id: '/{-$locale}/_auth/login'
      path: '/login'
      fullPath: '/{-$locale}/login'
      preLoaderRoute: typeof Char123LocaleChar125AuthLoginRouteImport
      parentRoute: typeof Char123LocaleChar125AuthRouteRoute
    }
  }
}

interface Char123LocaleChar125AuthRouteRouteChildren {
  Char123LocaleChar125AuthLoginRoute: typeof Char123LocaleChar125AuthLoginRoute
}

const Char123LocaleChar125AuthRouteRouteChildren: Char123LocaleChar125AuthRouteRouteChildren =
  {
    Char123LocaleChar125AuthLoginRoute: Char123LocaleChar125AuthLoginRoute,
  }

const Char123LocaleChar125AuthRouteRouteWithChildren =
  Char123LocaleChar125AuthRouteRoute._addFileChildren(
    Char123LocaleChar125AuthRouteRouteChildren,
  )

interface Char123LocaleChar125AdminPanelRouteRouteChildren {
  Char123LocaleChar125AdminPanelDashboardRoute: typeof Char123LocaleChar125AdminPanelDashboardRoute
  Char123LocaleChar125AdminPanelDocumentationRoute: typeof Char123LocaleChar125AdminPanelDocumentationRoute
  Char123LocaleChar125AdminPanelInquiriesRoute: typeof Char123LocaleChar125AdminPanelInquiriesRoute
  Char123LocaleChar125AdminPanelOrdersRoute: typeof Char123LocaleChar125AdminPanelOrdersRoute
  Char123LocaleChar125AdminPanelReviewsRoute: typeof Char123LocaleChar125AdminPanelReviewsRoute
  Char123LocaleChar125AdminPanelServiceCategoriesRoute: typeof Char123LocaleChar125AdminPanelServiceCategoriesRoute
  Char123LocaleChar125AdminPanelServicesRoute: typeof Char123LocaleChar125AdminPanelServicesRoute
  Char123LocaleChar125AdminPanelUsersRoute: typeof Char123LocaleChar125AdminPanelUsersRoute
}

const Char123LocaleChar125AdminPanelRouteRouteChildren: Char123LocaleChar125AdminPanelRouteRouteChildren =
  {
    Char123LocaleChar125AdminPanelDashboardRoute:
      Char123LocaleChar125AdminPanelDashboardRoute,
    Char123LocaleChar125AdminPanelDocumentationRoute:
      Char123LocaleChar125AdminPanelDocumentationRoute,
    Char123LocaleChar125AdminPanelInquiriesRoute:
      Char123LocaleChar125AdminPanelInquiriesRoute,
    Char123LocaleChar125AdminPanelOrdersRoute:
      Char123LocaleChar125AdminPanelOrdersRoute,
    Char123LocaleChar125AdminPanelReviewsRoute:
      Char123LocaleChar125AdminPanelReviewsRoute,
    Char123LocaleChar125AdminPanelServiceCategoriesRoute:
      Char123LocaleChar125AdminPanelServiceCategoriesRoute,
    Char123LocaleChar125AdminPanelServicesRoute:
      Char123LocaleChar125AdminPanelServicesRoute,
    Char123LocaleChar125AdminPanelUsersRoute:
      Char123LocaleChar125AdminPanelUsersRoute,
  }

const Char123LocaleChar125AdminPanelRouteRouteWithChildren =
  Char123LocaleChar125AdminPanelRouteRoute._addFileChildren(
    Char123LocaleChar125AdminPanelRouteRouteChildren,
  )

interface Char123LocaleChar125RouteRouteChildren {
  Char123LocaleChar125AuthRouteRoute: typeof Char123LocaleChar125AuthRouteRouteWithChildren
  Char123LocaleChar125AdminPanelRouteRoute: typeof Char123LocaleChar125AdminPanelRouteRouteWithChildren
  Char123LocaleChar125IndexRoute: typeof Char123LocaleChar125IndexRoute
  Char123LocaleChar125OrderPrintoutOrderIdRoute: typeof Char123LocaleChar125OrderPrintoutOrderIdRoute
}

const Char123LocaleChar125RouteRouteChildren: Char123LocaleChar125RouteRouteChildren =
  {
    Char123LocaleChar125AuthRouteRoute:
      Char123LocaleChar125AuthRouteRouteWithChildren,
    Char123LocaleChar125AdminPanelRouteRoute:
      Char123LocaleChar125AdminPanelRouteRouteWithChildren,
    Char123LocaleChar125IndexRoute: Char123LocaleChar125IndexRoute,
    Char123LocaleChar125OrderPrintoutOrderIdRoute:
      Char123LocaleChar125OrderPrintoutOrderIdRoute,
  }

const Char123LocaleChar125RouteRouteWithChildren =
  Char123LocaleChar125RouteRoute._addFileChildren(
    Char123LocaleChar125RouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  Char123LocaleChar125RouteRoute: Char123LocaleChar125RouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
